(() => {
  const carousel = document.querySelector('[data-review-carousel]');
  if (!carousel) return;
  const cards = [...carousel.querySelectorAll('blockquote')];
  const previous = document.querySelector('[data-review-prev]');
  const next = document.querySelector('[data-review-next]');
  let index = 0;
  let timer;
  const visibleCards = () => window.matchMedia('(max-width: 800px)').matches ? 1 : 3;
  const show = newIndex => {
    const lastStart = Math.max(0, cards.length - visibleCards());
    index = newIndex > lastStart ? 0 : newIndex < 0 ? lastStart : newIndex;
    carousel.scrollTo({ left: cards[index].offsetLeft - carousel.offsetLeft, behavior: 'smooth' });
  };
  const start = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    clearInterval(timer);
    timer = setInterval(() => show(index + 1), 4500);
  };
  previous?.addEventListener('click', () => { show(index - 1); start(); });
  next?.addEventListener('click', () => { show(index + 1); start(); });
  carousel.addEventListener('mouseenter', () => clearInterval(timer));
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', () => clearInterval(timer));
  carousel.addEventListener('focusout', start);
  window.addEventListener('resize', () => show(index));
  start();
})();
